import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { startOfMonth, subMonths } from "date-fns";

import type { RootState } from "@/store";

export interface PaymentInfosReducerInterface {
  month: Date;
}

const initialState: PaymentInfosReducerInterface = {
  month: subMonths(startOfMonth(new Date()), 1),
};

const paymentInfosSlice = createSlice({
  name: "paymentInfos",
  initialState,
  reducers: {
    resetFilters(state) {
      state.month = subMonths(startOfMonth(new Date()), 1);
    },

    setMonth(state, action: PayloadAction<Date>) {
      state.month = action.payload;
    },
  },
});

export const { resetFilters, setMonth } = paymentInfosSlice.actions;
export const paymentInfosSelector = (state: RootState) => state.paymentInfos;
export default paymentInfosSlice.reducer;
